import React from "react";

const defaultRecallData = [
  { type: "Voluntary recalls", number: "", reason: "" },
  { type: "Forced recalls", number: "", reason: "" },
];

const ProductRecallTable = ({ recallData, setRecallData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...recallData];
    updated[index][field] = value;
    setRecallData(updated);
  };

  const cell = {
    border: "1px solid #000",
    padding: "15px",
    textAlign: "center",
    verticalAlign: "middle",
  };

  const leftCell = {
    ...cell,
    textAlign: "left",
    fontWeight: "bold",
    width: "33%",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
  };

  const inputStyle = {
    width: "100%",
    padding: "10px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
    boxSizing: "border-box",
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={header}></th>
            <th style={header}>Number</th>
            <th style={header}>Reasons for Recall</th>
          </tr>
        </thead>
        <tbody>
          {recallData.map((row, index) => (
            <tr key={index}>
              <td style={leftCell}>{row.type}</td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="No."
                  value={row.number}
                  onChange={(e) =>
                    handleChange(index, "number", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Details"
                  value={row.reason}
                  onChange={(e) =>
                    handleChange(index, "reason", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductRecallTable;
